export const breakLoop = {
  configuration: {
    loopHash: "Break Element"
  }
};
